import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Material
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';

// Directives
import { TimeMaskDirective } from './directives/time-mask.directive';

// Pipes
import { IncludesByPipe } from './pipes/includes-by.pipe';
import { RrulePipe } from './pipes/rrule.pipe';

// Components
import { SelectComponent } from './components/select/select.component';
import { MoveElementDirective } from './directives/move-element.directive';
import { HighlightSearchPipe } from './pipes/highlight-search.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    // Material
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
  ],
  declarations: [
    SelectComponent,
    TimeMaskDirective,
    MoveElementDirective,
    IncludesByPipe,
    TimeFormatPipe,
    RrulePipe,
    HighlightSearchPipe,
  ],
  exports: [
    SelectComponent,
    TimeMaskDirective,
    MoveElementDirective,
    IncludesByPipe,
    TimeFormatPipe,
    HighlightSearchPipe,
  ],
  providers: [
    IncludesByPipe,
    TimeFormatPipe,
    RrulePipe,
    HighlightSearchPipe,
  ]
})
export class ElementsModule { }
